export const SECTIONS = {
    ORBITAL: 'orbital-section',
};
export const EL = {
    LATITUDE: 'sat-latitude',
    LONGITUDE: 'sat-longitude',
    ALTITUDE: 'sat-altitude',
    PERIOD: 'sat-period',
    VELOCITY: 'sat-velocity',
    INCLINATION: 'sat-inclination',
    ECCENTRICITY: 'sat-eccentricity',
    RAAN: 'sat-raan',
    ARG_PE: 'sat-argPe',
    MEAN_ANOMALY: 'sat-meanAnomaly',
    APOGEE: 'sat-apogee',
    PERIGEE: 'sat-perigee',
    ELSET_AGE: 'sat-elset-age',
    UNCERTAINTY_RADIAL: 'sat-uncertainty-radial',
    UNCERTAINTY_INTRACK: 'sat-uncertainty-intrack',
    UNCERTAINTY_CROSSTRACK: 'sat-uncertainty-crosstrack',
};
